import { Dayjs } from "dayjs";
import { Controller } from "react-hook-form";

import { IconCalendar } from "@pentabd/icons";
import { InputDate } from "@pentabd/ui";

interface InputDateControllerType {
  register?: any;
  control: any;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  errors?: any;
  portal?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  maximumDate?: Dayjs;
  minimumDate?: Dayjs;
  onSelectDate?: (date: string) => void;
  isTimePicker?: boolean;
}

export const InputDateController = ({
  name,
  control,
  errors,
  placeholder,
  disabled,
  portal = false,
  size = "md",
  minimumDate,
  maximumDate,
  onSelectDate,
  isTimePicker,
}: InputDateControllerType) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <InputDate
          isTimePicker={isTimePicker}
          size={size}
          name={name}
          minimumDate={minimumDate}
          maximumDate={maximumDate}
          onSelectDate={(date) => {
            onSelectDate && onSelectDate(date);
            field.onChange(date);
          }}
          defaultValue={field.value as string}
          error={errors}
          placeholder={placeholder}
          prefix={
            <IconCalendar size={size === "xs" ? "16" : "20"} fill="subtitle2" />
          }
          disabled={disabled}
          portal={portal}
          className="z-10"
        />
      )}
    />
  );
};
